<template>
<v-container class="fill-height data-container" fluid>

    <div id="ag-grid-container">
        <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
            :gridOptions="gridOptions"
            @row-double-clicked="(params) => $emit('edit', params.data)"
            :groupHeaders="true"
            :rowHeight="40">
        </ag-grid-vue>
    </div>

</v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
export default {
    name: 'ThresholdProfileList',
    props: ['thresholdProfileList', 'lockSave'],
    components: {
    'ag-grid-vue': AgGridVue,
    },
    data: () => ({
        showGrid: false,
        gridOptions: null,
    }),

    computed: {

    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.thresholdProfileList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.api.autoSizeColumns(); 
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'thresholdProfilesList');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 120, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle threshold-profile-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle threshold-profile-action" style="cursor: ${self.$props.lockSave ? 'default' : 'pointer'}; color: ${self.$props.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-content-copy threshold-profile-action" style="cursor: ${self.$props.lockSave ? 'default' : 'pointer'}; color: ${self.$props.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
                            this.cloneButtonHandler = this.cloneButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.threshold-profile-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.threshold-profile-action')[1];
                            this.cloneButton = this.eGui.querySelectorAll('.threshold-profile-action')[2];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                            this.cloneButton.addEventListener('click', this.cloneButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        cloneButtonHandler(event) {
                            event.stopPropagation();
                            this.params.cloneFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                            this.cloneButton.removeEventListener('click', this.cloneButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.$emit('edit', params.data);
                        },
                        deleteFunction: (params) => {
                            if(!this.$props.lockSave) {
                                this.$emit('delete', params.data.tp_id);
                            }
                        },
                        cloneFunction: (params) => {
                            if(!this.$props.lockSave) {
                                this.$emit('clone', params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Threshold Profile Name', 
                    field: 'tp_name', 
                    width: 250, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
            ];
            return columnDefs;
        },
    },

    watch: {
    },

    mounted() {
        this.buildAgGrid();
    }

  
};
</script>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
        width: 100%;
    }

</style>
